import { ColorHex } from '@axafr-btc-ds/colors';
import { Typography } from '@axafr-btc-ds/typography';
import styles from './Price.module.css';
import { PriceProps } from './Price.interface';

export const Price = ({ amount, suffix }: PriceProps) => {
    const [ amountIntegerPart, amountDecimalPartWithSymbol ] = amount.split(',');

    return (
        <div>
            <Typography color={ ColorHex.axablue } component="span" variant='title1' className={ styles.integer }>{ amountIntegerPart }</Typography>
            <Typography color={ ColorHex.axablue } component="span" variant='title1' className={ styles.coma }>,{ amountDecimalPartWithSymbol } €</Typography>
            <Typography color={ ColorHex.axablue } component="span" variant='title1' className={ styles.suffix }>{ suffix }</Typography>
        </div>
    );
};
